// Carga diferida de pantallas tolerante a red lenta / servidor arrancando / deploy nuevo.
// Reintenta el import con espera progresiva y, como última opción, recarga la página UNA vez
// (toma el index.html y los chunks nuevos tras una publicación). Si aún falla, propaga el error
// para que ErrorBoundary muestre una pantalla amigable con "Reintentar".
import { lazy } from 'react';

const ESPERAS_MS = [1500, 3000, 6000];
const esperar = (ms) => new Promise((r) => setTimeout(r, ms));

export const lazyResiliente = (importer, nombre) => lazy(async () => {
  const claveRecarga = `freshen_chunk_reload_${nombre}`;
  for (let intento = 0; ; intento++) {
    try {
      const mod = await importer();
      sessionStorage.removeItem(claveRecarga);
      return mod;
    } catch (e) {
      if (intento < ESPERAS_MS.length) {
        await esperar(ESPERAS_MS[intento]);
        continue;
      }
      if (navigator.onLine && !sessionStorage.getItem(claveRecarga)) {
        sessionStorage.setItem(claveRecarga, '1');
        window.location.reload();
        await esperar(15000); // la recarga toma el control
      }
      throw e;
    }
  }
});

// Pre-carga en segundo plano de las pantallas más usadas (quedan en caché del service worker).
export const precargarPantallas = (importers) => {
  const correr = () => importers.forEach((imp) => { imp().catch(() => {}); });
  if ('requestIdleCallback' in window) window.requestIdleCallback(correr, { timeout: 8000 });
  else setTimeout(correr, 4000);
};
